module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAxNyI+CiAgPGRlZnMvPgogIDxwYXRoIGZpbGw9IiM0MjQyNDIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE1LjYgMS4zYy4zLjQuMSAxLS4zIDEuM0w2LjUgNy41aDE2LjlhMSAxIDAgMDEuMSAySDYuNWw4LjcgNC45Yy41LjIuNy44LjUgMS4ydi4xYTEgMSAwIDAxLTEuMy41aC0uMWwtMTItNi44LTEuNi0uOSAxLjYtLjkgMTItNi43YTEgMSAwIDAxMS4zLjR6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/navi/images/prev.svg
// module id = 8ce143db288f0102cc84
// module chunks = 7